// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : LAST EMI DEATILS SERVICE CREATED
// MODIFIED DATE: 23-08-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET LAST EMI DEATILS START *********************** */
export const getLastEMIDetails = (listData: any) => {
	const data = {
		GetLastEMIDetailsRecordToken: listData,
	};
	const url = `${API_URL}getBranchESAFLastEMIRecords`;
	return makeApiCall(url, data);
};
/** ***************** GET LAST EMI DEATILS END *********************** */
